import { render, staticRenderFns } from "./InstrumentGroup.vue?vue&type=template&id=fc5d445c&"
import script from "./InstrumentGroup.vue?vue&type=script&lang=js&"
export * from "./InstrumentGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports